import LucideMessageSquareText from '~icons/lucide/message-square-text'
import { cx } from 'src/utils/cx'
import { formatNum } from 'src/utils/formatNum'
import { useScrollToComments } from './commentsScroll'

export function CommentCountButton({
  count,
  className,
  style,
}: StyleProps & { count: number }) {
  const scrollToComments = useScrollToComments()
  return (
    <button
      type="button"
      aria-label="Jump to comments"
      onClick={scrollToComments}
      className={cx(
        'cursor-pointer transition -m-2 p-2 rounded-md',
        'focus-within:outline focus-within:outline-1',
        className,
      )}
      style={style}
    >
      <div className="flex gap-1 items-center">
        <LucideMessageSquareText className="size-5 text-zinc-400" />
        <span className="text-sm tabular-nums">{formatNum(count)}</span>
      </div>
    </button>
  )
}
